import { client as _heyApiClient } from './client.gen';
export const getHealthz = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/healthz',
        ...options
    });
};
export const getMe = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/me',
        ...options
    });
};
export const getSession = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/session',
        ...options
    });
};
export const postSession = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/session',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postRefreshToken = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/refresh-token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const getJwtKeys = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/jwt-keys',
        ...options
    });
};
export const postSignInUsernamePassword = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/sign-in-username-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postSignInActionCode = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/sign-in-action-code',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postSignUpWithUsernamePassword = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/sign-up-with-username-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postSignOut = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/sign-out',
        ...options
    });
};
export const postOtpSend = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/otp-send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postOtpVerify = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/otp-verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postChangePassword = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/change-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postResetPassword = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postStartImpersonate = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/start-impersonate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const postStopImpersonate = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/stop-impersonate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
//# sourceMappingURL=sdk.gen.js.map